/**
 * Chế độ triển khai của bản đang chạy: SaaS (mặc định) hay bản cài on-premise
 * (ADR-0058). Đọc lúc chạy từ `/config.json` (trường `deploymentMode`, nginx
 * sinh từ biến môi trường `DEPLOYMENT_MODE`, `web/nginx/spa.conf.template`), nên
 * một image dùng được cho cả hai chế độ.
 *
 * Bản on-premise mới có màn license cục bộ và băng cảnh báo license. Thiếu
 * tệp, tệp hỏng hay giá trị lạ đều là SaaS: không bao giờ tự bật màn gọi API
 * mà máy chủ không có.
 */
export type CheDoTrienKhai = 'SAAS' | 'ON_PREMISE';

export function chuanHoaCheDo(giaTri: unknown): CheDoTrienKhai {
  return typeof giaTri === 'string' && giaTri.trim().toUpperCase() === 'ON_PREMISE' ? 'ON_PREMISE' : 'SAAS';
}

let dangDoc: Promise<CheDoTrienKhai> | null = null;

/** Đọc một lần mỗi lần tải trang; `/config.json` không đổi trong phiên. */
export function docCheDoTrienKhai(): Promise<CheDoTrienKhai> {
  dangDoc ??= (async () => {
    try {
      const res = await fetch('/config.json', { cache: 'no-store' });
      if (!res.ok) return 'SAAS';
      const cfg = (await res.json()) as { deploymentMode?: unknown };
      return chuanHoaCheDo(cfg.deploymentMode);
    } catch {
      return 'SAAS';
    }
  })();
  return dangDoc;
}
